import { useBooking } from "../../lib/booking";

export default function Footer({ settings, services = [] }) {
  const { openBooking } = useBooking();
  if (!settings) return null;
  const smsHref = `sms:${settings.phone_digits}`;

  return (
    <footer
      data-testid="site-footer"
      style={{
        background: "var(--fs-ink)",
        borderTop: "1px solid var(--fs-line-strong)",
        padding: "5rem 0 2.5rem",
        color: "var(--fs-bg)",
      }}
    >
      <div className="fs-container grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: "2.4rem",
              fontWeight: 300,
              lineHeight: 1,
              marginBottom: "1.25rem",
              color: "var(--fs-bg)",
            }}
          >
            Friends Salon&nbsp;<span className="fs-ital" style={{ color: "var(--fs-caramel-bright)" }}>24</span>
          </div>
          <p style={{ color: "rgba(248,242,231,0.78)", fontSize: "0.95rem", lineHeight: 1.8, maxWidth: "440px" }}>
            York's by-appointment salon — open at any hour, any day, when booked at least 24
            hours ahead. Hair, locs, color & finishing by Rhon Friend and his handpicked team.
          </p>
          <p
            style={{
              marginTop: "1.5rem",
              fontFamily: "'Playfair Display', serif",
              fontStyle: "italic",
              color: "var(--fs-caramel-bright)",
              fontSize: "1rem",
              maxWidth: "440px",
            }}
          >
            “{settings.atelier_quote}”
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="fs-overline" style={{ color: "var(--fs-caramel-bright)", marginBottom: "1.25rem" }}>Services</h4>
          <ul className="space-y-2.5" style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {services.slice(0, 6).map((s) => (
              <li key={s.id}>
                <a href="#services" style={{ color: "rgba(248,242,231,0.78)", fontSize: "0.92rem" }}>
                  {s.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="fs-overline" style={{ color: "var(--fs-caramel-bright)", marginBottom: "1.25rem" }}>Visit</h4>
          <ul className="space-y-2.5" style={{ listStyle: "none", padding: 0, margin: 0, color: "rgba(248,242,231,0.78)", fontSize: "0.92rem" }}>
            <li>{settings.address_line}</li>
            <li>{settings.hours_line}</li>
            <li><a href={smsHref}>{settings.phone_display}</a> <span style={{ color: "rgba(248,242,231,0.45)", fontSize: "0.78rem" }}>(text only)</span></li>
            <li><a href={smsHref} data-testid="footer-text-cta">Text Us</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="fs-overline" style={{ color: "var(--fs-caramel-bright)", marginBottom: "1.25rem" }}>Book</h4>
          <ul className="space-y-2.5" style={{ listStyle: "none", padding: 0, margin: 0 }}>
            <li>
              <button
                type="button"
                onClick={openBooking}
                style={{ background: "transparent", border: "none", padding: 0, color: "rgba(248,242,231,0.78)", fontSize: "0.92rem", cursor: "pointer" }}
                data-testid="footer-book-cta"
              >
                Reserve a Chair
              </button>
            </li>
            <li>
              <a href="/admin" style={{ color: "rgba(248,242,231,0.55)", fontSize: "0.85rem" }} data-testid="footer-admin-link">
                Admin
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div
        className="fs-container"
        style={{
          marginTop: "4rem",
          paddingTop: "2rem",
          borderTop: "1px solid rgba(248,242,231,0.12)",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap: "1rem",
          fontSize: "0.7rem",
          letterSpacing: "0.22em",
          textTransform: "uppercase",
          color: "rgba(248,242,231,0.6)",
        }}
      >
        <span>© Friends Salon 24 · {settings.address_line}</span>
        <span>Royalty 2026</span>
      </div>
    </footer>
  );
}
